
import {
  Modal,
  ModalOverlay,
  ModalContent,
} from '@chakra-ui/react'
import style from './../css/dialogue.module.css'

function Dialogue({disclosure, title, cxt, onConfirm, showCancelBtn, onCancel}){

  const { isOpen, onOpen, onClose } = disclosure
  return(
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent className={style['modal-frame']} style={{
        backgroundColor: '#00000000',
        borderRadius: 0,
        fontFamily: "'Noto Serif TC', sans-serif",
      }}>
        <div className={[style['dlg-context-container']].join(' ')}>
          <label className={[style['shiny-string'], style['dlg-title']].join(' ')} data={title}>{title}</label>
          <label className={['row', 'items-center', 'justify-center', style['dlg-context']].join(' ')} dangerouslySetInnerHTML={{__html:cxt}}/>
          <div className={['row', 'items-center', showCancelBtn?'justify-between':'justify-center', style['btn-area']].join(' ')}>
            {showCancelBtn&&(
              <>
                <button className={['col-auto', 'row', 'items-center', 'justify-center', style['common-dlg-btn']].join(' ')} onClick={()=>{
                  if (onConfirm !==undefined){
                    onConfirm() 
                  }
                }}>
                  <label className={['col-auto', style['btn-lable-ok']].join(' ')}/>
                </button>
                
                <button className={['col-auto', 'row', 'items-center', 'justify-center', style['common-dlg-btn']].join(' ')} onClick={()=>{
                  if (onCancel !==undefined){
                    onCancel()
                  }
                }}>
                  <label className={['col-auto', style['btn-lable-cancel']].join(' ')}/>
                </button>
              </>
            )}
          </div>
        </div>
        {showCancelBtn?<></>:(
          <button className={[style['close-btn']].join(' ')} onClick={()=>{
            onClose()
          }}/>          
        )}

      </ModalContent>
    </Modal>
  )
}
export default Dialogue